import { InjectionToken } from '@angular/core';

export interface CarePlanDomain {
  key: string;
  label: string;
  order: number;
}

export interface CarePlanObjective {
  key: string;
  label: string;
  domainKey: string;
}

export interface CarePlanFixtureTaxonomy {
  domains: readonly CarePlanDomain[];
  objectives: readonly CarePlanObjective[];
}

/**
 * Test-only taxonomy seam for fixture-backed Goal tests. Application runtime
 * intentionally does not provide this token, so the static catalogue is not
 * reachable from the production bundle.
 */
export const CARE_PLAN_FIXTURE_TAXONOMY =
  new InjectionToken<CarePlanFixtureTaxonomy>('CARE_PLAN_FIXTURE_TAXONOMY');
